document.querySelectorAll('.footer-menu-b7 .menu-list').forEach((el, i) => {
  const btn = el.querySelector('.menu-btn');
  const depth02 = el.querySelector('.menu-depth02');

  btn.addEventListener('click', () => {
    btn.classList.toggle('active');
    depth02.classList.toggle('active');

    if (depth02.classList.contains('active')) {
      depth02.style.height = depth02.scrollHeight + 'px';
    } else {
      depth02.style.height = '';
    }
  })
})